// extracted by mini-css-extract-plugin
export default {"overlay":"UpdateNotification_overlay__c3TIl","banner":"UpdateNotification_banner__FHTHe","text":"UpdateNotification_text__jN4Oh","button":"UpdateNotification_button__b+-cC"};